import { render, staticRenderFns } from "./DraggableBlocks.vue?vue&type=template&id=06e091c5"
import script from "./DraggableBlocks.vue?vue&type=script&lang=js"
export * from "./DraggableBlocks.vue?vue&type=script&lang=js"
import style0 from "./DraggableBlocks.vue?vue&type=style&index=0&id=06e091c5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports